module.exports = __webpack_public_path__ + "static/media/btsexpress-logo.615a2bdf.png";